export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70250b1a3b22e63d7fc816ad046804947ce230faca&name=pushAdClickData!'